import React, { createContext, useContext, ReactNode } from 'react';
import { usePersistedSongs, usePersistedArtists, usePersistedUser, AppData } from '../hooks/usePersistedData';

const DataContext = createContext<AppData | undefined>(undefined);

interface DataProviderProps {
  children: ReactNode;
}

export const DataProvider: React.FC<DataProviderProps> = ({ children }) => {
  const { songs, addSong, updateSong, deleteSong } = usePersistedSongs();
  const { artists, addArtist, updateArtist, deleteArtist } = usePersistedArtists();
  const { user, updateUser } = usePersistedUser();

  const value: AppData = {
    songs,
    artists,
    user,
    addSong,
    updateSong,
    deleteSong,
    addArtist,
    updateArtist,
    deleteArtist,
    updateUser,
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

export const useAppData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useAppData must be used within a DataProvider');
  }
  return context;
};